import { combineReducers } from 'redux';
import { myCompleteReview, myRecentReview, myReviewDelete } from './myReviewsPageReducer';

const myReviews = combineReducers({
	myCompleteReview,
	myRecentReview,
	myReviewDelete
});

export default myReviews;
